/**
 * True when insight_json (or API insight object) uses the Quick Clarity result contract.
 */
export function isQuickClarityInsight(insightOrJson) {
  if (!insightOrJson || typeof insightOrJson !== "object") return false;
  const j = insightOrJson.insight_json && typeof insightOrJson.insight_json === "object"
    ? insightOrJson.insight_json
    : insightOrJson;
  if (j.schema_version === "quick_clarity" || j.mode === "quick_clarity") return true;
  if (typeof j.primary_insight === "string" && j.primary_insight.trim()) return true;
  if (typeof j.understanding === "string" && j.understanding.trim()) return true;
  return false;
}
